'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserRejectedTransactionError = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserRejectedTransactionError = exports.UserRejectedTransactionError = function (_Error) {
  _inherits(UserRejectedTransactionError, _Error);

  function UserRejectedTransactionError() {
    var _ref;

    _classCallCheck(this, UserRejectedTransactionError);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = UserRejectedTransactionError.__proto__ || Object.getPrototypeOf(UserRejectedTransactionError)).call.apply(_ref, [this].concat(args)));

    _this.name = 'UserRejectedTransactionError';
    // Maintains proper stack trace for where our error was thrown (only available on V8).
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, UserRejectedTransactionError);
    }
    return _this;
  }

  return UserRejectedTransactionError;
}(Error);

/**
 * Responsible for all authenticated operations against the eth network
 */


var EthWallet = function () {
  function EthWallet(type, connectionPool) {
    var defaultFetchPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck(this, EthWallet);

    this.type = type;
    this.pool = connectionPool;
    this.defaultFetchPosition = defaultFetchPosition;
  }

  /**
   * Returns the type of wallet that this is
   */


  _createClass(EthWallet, [{
    key: 'getType',
    value: function getType() {
      return this.type;
    }

    /**
     * Gets the current address from the user's wallet
     *
     * @param {Number} position
     * @return {Promise<String | null>}
     */

  }, {
    key: 'getAddress',
    value: function getAddress() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.defaultFetchPosition;

      return this.pool.withConnection(function (eth) {
        return eth.getAccounts().then(function (accounts) {
          return accounts[position] || null;
        });
      });
    }

    /**
     * Checks which network we are pointed at
     *
     * @return {Promise<number>}
     */

  }, {
    key: 'getNetwork',
    value: function getNetwork() {
      return this.pool.withConnection(function (eth) {
        return eth.net.getId();
      });
    }

    /**
     *
     * Sends a transaction created by a contract method
     *
     * @param {Object} transaction
     * @param {Bool} returnOnReceipt
     * @return {Promise<String>} - transaction hash
     */

  }, {
    key: 'sendTransaction',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(transaction) {
        var returnOnReceipt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.pool.withConnection(function (eth) {
                  return new Promise(function (resolve, reject) {
                    var promiEvent = eth.sendTransaction(transaction);
                    // Wait for receipt, or resolve on txHash.
                    if (returnOnReceipt) {
                      promiEvent.on('receipt', resolve);
                    } else {
                      promiEvent.on('transactionHash', resolve);
                    }
                    promiEvent.on('error', reject);
                  });
                });

              case 3:
                return _context.abrupt('return', _context.sent);

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

                if (!(_context.t0.message.indexOf('User denied transaction signature') !== -1 || _context.t0.message.indexOf('@moz-extension') !== -1 || _context.t0.message.indexOf('Condition of use not satisfied') !== -1 || _context.t0.message.indexOf('Invalid status 6985') !== -1 || _context.t0.message.indexOf('Failed to sign with Ledger device') !== -1)) {
                  _context.next = 10;
                  break;
                }

                throw new UserRejectedTransactionError('Cancelled');

              case 10:
                throw _context.t0;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function sendTransaction(_x4) {
        return _ref2.apply(this, arguments);
      }

      return sendTransaction;
    }()
  }]);

  return EthWallet;
}();

exports.default = EthWallet;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/EthWallet.js
// module id = 1189
// module chunks = 0